// The count of this till's own open orders, which the top bar shows (#352).
//
// It is the store's own count, the orders the Orders list shows as Open, of
// every trading day. Only this till writes them, so the screen asks again after
// each write the store answers and when the till starts or unlocks, and takes
// the count from every read of the store's state or day that Orders makes. It
// never polls for it and never asks the server. When the store does not answer,
// the last count stays until the next read.

import { store } from '../api/client';
import { onOpenOrderWrite } from './shell';

let count = $state(0);
// Reads can overlap when two writes come close. An answer older than one
// already taken is dropped, and a read that fails never drops a good one.
let started = 0;
let taken = 0;

/** How many open orders this till holds, as the store last said. */
export function openCount(): number {
	return count;
}

/** Take a count a read of the store's state or day just gave. */
export function setOpenCount(next: number): void {
	count = next;
}

/** Read the count from the store again. */
export async function refreshOpenCount(): Promise<void> {
	const mine = ++started;
	try {
		const { data, error } = await store.GET('/store/state');
		if (error !== undefined || !data || mine < taken) return;
		taken = mine;
		count = data.openOrders;
	} catch {
		// The store did not answer: the last count stands.
	}
}

/** Keep the count current after each of this till's writes, until the stop it returns. */
export function watchOpenCount(): () => void {
	return onOpenOrderWrite(() => void refreshOpenCount());
}
